module.exports = __webpack_public_path__ + "static/emblem-ce39fecab048164dc0e0f3740cb66e33.png";